function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#c5c0d6",
  d: "M130 6.398L61.41 41.691 58.66 36.29 127.245 1z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.595,
  d: "M130 6.398L61.41 41.691 58.66 36.29 127.245 1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5c0d6",
  d: "M75.22 27.623l2.583 5.403"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.595,
  d: "M75.22 27.623l2.583 5.403"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#72659F",
  d: "M130 6.409L77.803 33.236l-2.762-5.41L127.237 1z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M84.976 74.71c-.724-.692-2.189-1.09-2.189-1.09s1.48-.565 2.206-1.278c.725-.711 1.124-2.174 1.124-2.174s.535 1.463 1.32 2.28c.786.816 2.147 1.172 2.147 1.172s-1.466.398-2.203 1.142c-.735.747-1.264 2.177-1.264 2.177s-.418-1.543-1.14-2.23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#72659F",
  d: "M80.255 80.264c0-.695.567-1.26 1.266-1.26.698 0 1.266.565 1.266 1.26 0 .694-.568 1.26-1.266 1.26-.699 0-1.266-.566-1.266-1.26M3.457 86.25C2.315 85.163 0 84.536 0 84.536s2.338-.897 3.482-2.018c1.146-1.127 1.778-3.43 1.778-3.43s.84 2.303 2.08 3.597c1.242 1.29 3.39 1.851 3.39 1.851s-2.315.627-3.477 1.803c-1.158 1.176-1.993 3.434-1.993 3.434s-.662-2.437-1.803-3.521M78.191 42.61c-.949-.902-2.87-1.421-2.87-1.421s1.94-.741 2.89-1.675c.953-.934 1.475-2.847 1.475-2.847s.698 1.913 1.727 2.985c1.032 1.072 2.813 1.537 2.813 1.537s-1.92.52-2.885 1.496c-.961.974-1.655 2.85-1.655 2.85s-.549-2.023-1.495-2.925M71.137 46.792c0-.693.567-1.256 1.266-1.256.699 0 1.265.563 1.265 1.256 0 .699-.566 1.262-1.265 1.262a1.262 1.262 0 0 1-1.266-1.262"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5c0d6",
  d: "M82.06 122.335l-7.657-57.568H21.245l-7.656 57.568c-.06.254-.102.507-.102.762 0 5.77 15.374 10.444 34.337 10.444 18.964 0 34.338-4.674 34.338-10.442 0-.257-.043-.51-.102-.764z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.595,
  d: "M82.162 123.1v-.003c0-.255-.043-.508-.102-.762l-7.657-57.568H21.245l-7.656 57.568c-.06.254-.102.507-.102.762v.002c0 5.768 15.374 10.442 34.337 10.442 18.964 0 34.338-4.674 34.338-10.442z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5c0d6",
  d: "M84.92 62.807c0 6.492-16.608 11.753-37.095 11.753-20.488 0-37.096-5.261-37.096-11.753 0-6.489 16.608-11.752 37.096-11.752 20.487 0 37.094 5.263 37.094 11.752"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.595,
  d: "M84.92 62.807c0 6.492-16.608 11.753-37.095 11.753-20.488 0-37.096-5.261-37.096-11.753 0-6.489 16.608-11.752 37.096-11.752 20.487 0 37.094 5.263 37.094 11.752z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#72659F",
  d: "M74.112 62.807c0 3.387-11.542 6.128-25.779 6.128s-25.78-2.74-25.78-6.128c0-3.384 11.543-6.13 25.78-6.13 14.237 0 25.78 2.746 25.78 6.13"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5c0d6",
  d: "M29.276 79.817s16.366 4.049 37.095.23"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.595,
  d: "M29.276 79.817s16.366 4.049 37.095.23"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#72659F",
  d: "M35.025 28.664c0-1 .815-1.811 1.817-1.811 1.005 0 1.819.811 1.819 1.81 0 .998-.814 1.808-1.82 1.808a1.814 1.814 0 0 1-1.816-1.807"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M41.718 20.073c-1.613-1.538-4.876-2.42-4.876-2.42s3.297-1.263 4.912-2.844c1.616-1.587 2.505-4.84 2.505-4.84s1.187 3.253 2.938 5.073c1.75 1.82 4.778 2.611 4.778 2.611s-3.263.882-4.902 2.546c-1.637 1.658-2.814 4.845-2.814 4.845s-.933-3.438-2.54-4.97z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#72659F",
  d: "M68.997 95.422c1.238 1.182 3.744 1.859 3.744 1.859s-2.532.972-3.772 2.188c-1.241 1.219-1.926 3.715-1.926 3.715s-.91-2.496-2.255-3.896c-1.343-1.402-3.671-2.007-3.671-2.007s2.507-.677 3.766-1.953c1.256-1.274 2.16-3.723 2.16-3.723s.717 2.641 1.954 3.817M74.112 109.039c0 .752-.614 1.364-1.37 1.364a1.369 1.369 0 0 1-1.372-1.364 1.37 1.37 0 0 1 1.372-1.366c.756 0 1.37.613 1.37 1.366M62.572 122.146c0 1.081-.884 1.96-1.97 1.96a1.966 1.966 0 0 1-1.97-1.96c0-1.085.881-1.962 1.97-1.962 1.086 0 1.97.877 1.97 1.962"
})));

function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 135,
    viewBox: "0 0 131 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c7af5e2d.svg";
export { ForwardRef as ReactComponent };